export default {};

export const HOUR_HEIGHT = 40;
export const INITIAL_SCALE = 0.5;
export const QUARTER_HEIGHT = HOUR_HEIGHT / 4;
export const RIGHT_OFFSET = 10;
export const ITEM_GAP = 3;
export const DAILY_LEFT_OFFSET = 60;
export const MONTHLY_ENTRY_HEIGHT = 20;
export const MONTHLY_HEADER_HEIGHT = 30;
export const MONTHLY_ENTRY_PADDING = 20;

export const BIWEEKLY_ROW_HEIGHT = 100;

export const BOTTOM_BUFFER = 2;

export const WEEKLY_BASE_OFFSET = 200;
export const WEEKLY_HEADER_BASE_HEIGHT = 28;
export const WEEKLY_HEADER_BLOCK_HEIGHT = 20;
export const WEEKLY_HEADER_PADDING = 2.5;
export const WEEKLY_HEADER_BLOCK_TOTAL_HEIGHT = (
  WEEKLY_HEADER_BLOCK_HEIGHT + (2 * WEEKLY_HEADER_PADDING)
);
export const USER_WEEK_HEADER_OFFSET_REDESIGN = 240;
export const USER_WEEK_HEADER_OFFSET_LEGACY = 200;
export const WEEKLY_HEADER_OFFSET_LEGACY = 50;

export const SCHEDULE_DATE_PICKER_TREE_OPTS = [
  {
    value: 'Calendar',
    title: 'Calendar',
    children: [
      {
        value: 'Day',
        title: 'Day',
      },
      {
        value: 'Week',
        title: 'Week',
      },
      {
        value: 'Month',
        title: 'Month',
      },
    ],
  },
  {
    value: 'User',
    title: 'User',
    labelPrefix: 'User:',
    children: [
      {
        value: 'UserDay',
        title: 'Day',
      },
      {
        value: 'UserWeekdays',
        title: 'Weekdays',
      },
      {
        value: 'UserWeek',
        title: 'Week',
      },
      {
        value: 'UserBiWeekly',
        title: 'Biweekly',
      },
    ],
  },
  {
    value: 'Equipment',
    title: 'Equipment',
    labelPrefix: 'Eqpt:',
    children: [
      {
        value: 'EquipmentDay',
        title: 'Day',
      },
      {
        value: 'EquipmentWeekdays',
        title: 'Weekdays',
      },
      {
        value: 'EquipmentWeek',
        title: 'Week',
      },
      {
        value: 'EquipmentBiWeekly',
        title: 'Biweekly',
      },
    ],
  },
];

export const USER_SCHEDULE_WEEKDAY_HEADERS = [
  'M',
  'T',
  'W',
  'T',
  'F',
];

export const USER_SCHEDULE_WEEK_HEADERS = [
  'S',
  'M',
  'T',
  'W',
  'T',
  'F',
  'S',
];

export const FILTER_VIEW_FIELDS = [
  {
    field: 'title',
    defaultValue: '',
  },
  {
    field: 'divisions',
    defaultValue: [],
  },
  {
    field: 'projects',
    defaultValue: [],
  },
  {
    field: 'phases',
    defaultValue: [],
  },
  {
    field: 'costcodes',
    defaultValue: [],
  },
  {
    field: 'users',
    defaultValue: [],
  },
  {
    field: 'equipment',
    defaultValue: [],
  },
  {
    field: 'equipmentTypes',
    defaultValue: [],
  },
  {
    field: 'description',
    defaultValue: '',
  },
  {
    field: 'forms',
    defaultValue: [],
  },
  {
    field: 'eventType',
    defaultValue: null,
  },
  {
    field: 'projectTypes',
    defaultValue: [],
  },
  {
    field: 'teams',
    defaultValue: [],
  },
  {
    field: 'drafts',
    defaultValue: false,
  },
  {
    field: 'published',
    defaultValue: false,
  },
];

export const SCHEDULE_SIDEBAR_CLOSED_STORAGE_KEY = 'isScheduleSideBarClosed';
